( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.lightbox' ).each( function() {
        $( this ).magnificPopup( {
          delegate: '.js-lightbox-image',
          type: 'image',
          gallery: {
            enabled: true,
            navigateByImgClick: false,
            preload: [0, 1],
            arrowMarkup:
              '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%">' +
                '<svg class="duration-theme ease-in-out text-theme-arrow-buttons-elements size-5 icon icon-arrow-right" aria-hidden="true">' +
                  '<use xlink:href="#icon-arrow-right"></use>' +
                '</svg>' +
              '</button>',
          },
          closeBtnInside: true,
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close">' +
              '<span class="sr-only">Close Popup</span>' +
              '<svg class="duration-150 pointer-events-none size-5 icon icon-exit" aria-hidden="true">' +
                '<use xlink:href="#icon-exit"></use>' +
              '</svg>' +
            '</button>',
          fixedContentPos: true,
          fixedBgPos: true,
          overflowY: 'auto',
          preloader: false,
          midClick: true,
          removalDelay: 300,
          mainClass: 'mfp-fade',
        } );
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'lightbox', COMPONENT );
} )( app );
